module.exports = __webpack_public_path__ + "img/F8.4ef78ccc.png";